import { API } from "../api/axios";
const END_POINT = "/periods";
const END_POINT_class = "/marks-by-class";

class NoteDetailSubjectService {
    getAllPeriode(classId,courseId) {
        return API.get(`${END_POINT}/${classId}/${courseId}`);
    }
    getAllnotes(classId,courseId,periodId) {
        return API.get(`${END_POINT_class}/${classId}/${courseId}/${periodId}`);
    }
}

export default new NoteDetailSubjectService();
